import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Typography,
  Container,
  Box,
  TextField,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";
import { message, Modal } from "antd";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from "@mui/icons-material/Search";
import imageCompression from "browser-image-compression";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../Components/PageTitle";
import Table from "../common/Table";
import {
  getTeachers,
  addTeacher,
  deleteTeacher,
} from "../../redux/actions/admin/teachersAction";
import EditTeacher from "./EditTeacher";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function TabPanel(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const Teachers = () => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const { teachers, loading } = useSelector((state) => state.teacher);
  const [filteredTeacher, setFilteredTeacher] = useState([]);
  const [search, setSearch] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [experience, setExperience] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [salary, setSalary] = useState("");
  const [teacherPublic, setTeacherPublic] = useState("");
  const [image, setImage] = useState(null);
  const [imageBase64, setImageBase64] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getTeachers());
  }, [dispatch]);

  useEffect(() => {
    setFilteredTeacher(teachers);
  }, [teachers]);

  // Function to refresh the admissions data
  const refreshData = () => {
    dispatch(getTeachers());
  };

  // Upload button functionality
  const VisuallyHiddenInput = styled("input")({
    display: "none",
  });

  // Handle search input change
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  // Filter teachers based on search query
  const filteredNewTeacher = filteredTeacher?.filter(
    (teacher) =>
      teacher.name.toLowerCase().includes(search.toLowerCase()) ||
      teacher.email.toLowerCase().includes(search.toLowerCase()) ||
      teacher.subject.toLowerCase().includes(search.toLowerCase())
  );

  // Compress the image
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    const maxSizeInMB = 25;

    if (file) {
      if (file.size / (1024 * 1024) > maxSizeInMB) {
        message.error(`Image size should not exceed ${maxSizeInMB} MB.`);
        return;
      }
      // Compress the image before conversion to base64
      const options = {
        maxSizeMB: 25,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };

      try {
        const compressedFile = await imageCompression(file, options);
        const reader = new FileReader();
        reader.onloadend = async () => {
          const imageBase64 = reader.result;
          setImage(imageBase64);
          setImageBase64(imageBase64);
        };
        reader.readAsDataURL(compressedFile);
      } catch (error) {
        console.error("Error compressing image:", error);
      }
    }
  };

  // Add Teacher
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("experience", experience);
    formData.append("salary", salary);
    formData.append("teacherPublic", teacherPublic);
    formData.append("teacherImage", imageBase64);
    await dispatch(addTeacher(formData));
    setName("");
    setEmail("");
    setPhone("");
    setExperience("");
    setSalary("");
    setSubject("");
    setTeacherPublic("");
    setImageBase64("");
    setImage(null);
    await dispatch(getTeachers());
  };

  // Delete Teacher
  const { confirm } = Modal;
  const handleDeleteTeacher = (id) => {
    confirm({
      title: "Are you sure you want to delete this Teacher?",
      content: "Once deleted, this teacher cannot be recovered.",
      okText: "Yes, Delete",
      cancelText: "No, Cancel",
      onOk: async () => {
        await dispatch(deleteTeacher(id));
        await dispatch(getTeachers());
      },
    });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "Actions",
      width: 90,
      renderCell: (value) => (
        <Box>
          <IconButton
            aria-label="delete"
            onClick={() => handleDeleteTeacher(value?.row?._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
          <EditTeacher
            id={value?.row?._id}
            teacher_TeacherImage={value?.row?.url}
            teacher_Name={value?.row?.name}
            teacher_Email={value?.row?.email}
            teacher_Phone={value?.row?.phone}
            teacher_Subject={value?.row?.subject}
            teacher_Experience={value?.row?.experience}
            teacher_Salary={value?.row?.salary}
            teacher_TeacherPublic={value?.row?.teacherPublic}
            refreshData={refreshData}
          />
        </Box>
      ),
    },
    {
      field: "url",
      headerName: "Image",
      width: 150,
      renderCell: (params) => (
        <img
          src={params.row.url}
          alt={params.row.teacherName}
          style={{ width: "100px", height: "auto", borderRadius: "5px" }}
        />
      ),
    },

    {
      field: "name",
      headerName: "Name",
      width: 150,
      editable: true,
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 200,
      editable: true,
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 150,
      editable: true,
    },

    {
      field: "subject",
      headerName: "Subject",
      width: 130,
      editable: true,
    },

    {
      field: "experience",
      headerName: "Experience",
      width: 120,
      editable: true,
    },

    {
      field: "salary",
      headerName: "Salary",
      width: 110,
      editable: true,
    },

    {
      field: "teacherPublic",
      headerName: "Public",
      width: 110,
      editable: true,
    },

    {
      field: "createdAt",
      headerName: "Date",
      width: 120,
      renderCell: (params) =>
        moment(params?.row?.createdAt).format("MM/DD/YYYY"),
    },
  ];

  return (
    <>
      <PageTitle
        title="Manage Teachers - Admin Panel | Shree Mangalam School"
        description="Add, edit, or remove teacher profiles through the Admin Panel of Shree Mangalam School. Maintain faculty details and academic assignments with ease."
        url="/admin/teachers"
        keywords="admin teachers management, manage faculty, Shree Manglam teachers, teacher profile admin, school faculty admin panel"
      />

      <Box>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            mb: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#2C3E50",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          Teachers
        </Typography>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            mb: 5,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <MUILink
            component={Link}
            to="/dashboard"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Dashboard
          </MUILink>
          <Typography sx={{ color: "primary.main" }}>Teachers</Typography>
        </Breadcrumbs>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Teachers List" {...TabPanel(0)} />
            <Tab label="Add Teacher" {...TabPanel(1)} />
          </Tabs>
        </Box>

        {/* Teachers List */}
        <CustomTabPanel value={value} index={0}>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Teachers List
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search by Name, Email & Subject"
            value={search}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <IconButton>
                  <SearchIcon sx={{ color: "#1976d2" }} />
                </IconButton>
              ),
            }}
            sx={{
              mb: 3,
              mt: 2,
              bgcolor: "white",
              borderRadius: "20px",
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
            }}
          />
          <Box
            style={{
              width: "auto",
              overflowY: "hidden",
              overflowX: "scroll",
            }}
          >
            <Box
              sx={{
                pb: 2,
                display: "flex",
                width: "auto",
                justifyContent: "right",
              }}
            ></Box>
            <Table data={filteredNewTeacher} columns={columns} />
          </Box>
        </CustomTabPanel>

        {/* Add a New Teacher */}
        <CustomTabPanel value={value} index={1} maxWidth>
          <Typography
            variant="h6"
            sx={{
              pb: 2,
              pt: 3,
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
              lineHeight: 1.8,
            }}
          >
            Create a new Teacher
          </Typography>
          <Container
            onSubmit={handleSubmit}
            component="form"
            className="form_style border-style"
            maxWidth
          >
            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherName"
              label="Teacher Name *"
              name="teacherName"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Teacher Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherEmail"
              label="Teacher Email *"
              name="teacherEmail"
              type="email"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Teacher Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherPhone"
              label="Teacher Phone *"
              name="teacherPhone"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Teacher Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherSubject"
              label="Teacher Subject *"
              name="teacherSubject"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Teacher Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherExperience"
              label="Teacher Experience (Years)*"
              name="teacherExperience"
              InputLabelProps={{
                shrink: true,
              }}
              type="number"
              placeholder="Teacher Experience (Years)"
              value={experience}
              onChange={(e) => setExperience(e.target.value)}
            />

            <TextField
              sx={{
                mb: 3,
                "& .MuiInputBase-root": {
                  color: "text.secondary",
                },
                "& input[type='number']": {
                  MozAppearance: "textfield",
                  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                },
                fieldset: { borderColor: "rgb(231, 235, 240)" },
              }}
              fullWidth
              id="teacherSalary"
              label="Teacher Salary (Monthly)"
              name="teacherSalary"
              InputLabelProps={{
                shrink: true,
              }}
              type="number"
              placeholder="Teacher Salary (Monthly)"
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
            />

            <Box sx={{ mb: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="teacher-public-label">
                  Teacher Public
                </InputLabel>
                <Select
                  labelId="teacher-public-label"
                  id="teacher-public"
                  value={teacherPublic}
                  label="Teacher Public *"
                  onChange={(e) => setTeacherPublic(e.target.value)}
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box>
              <VisuallyHiddenInput
                accept="image/*"
                id="contained-button-file"
                type="file"
                onChange={handleImageUpload}
              />
              <label htmlFor="contained-button-file">
                <Button
                  variant="outlined"
                  color="primary"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                >
                  Teacher Image
                </Button>
              </label>
              {image && (
                <Box mt={3} display="flex" alignItems="center">
                  <img
                    src={image}
                    alt="avatar"
                    style={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
              )}
            </Box>

            <Button
              sx={{ mt: 3 }}
              variant="contained"
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Add Teacher"}
            </Button>
          </Container>
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default Teachers;
